<ng-container *ngIf="!kpiChartIdentifier; else kpiBlock">
  <div class="chart-header">
    <h2 class="chart-title">{{ chartTitle }}</h2>
    <ng-container *ngIf="expandedView">
      <button (click)="onExpandButtonClick()" class="chart-expanded-view-button">
        <mat-icon svgIcon="enlarge" class="chart-expanded-view-icon"></mat-icon>
      </button>
    </ng-container>
  </div>
  <ng-container *ngIf="render">
    <div
      echarts
      (chartInit)="onChartInit($event)"
      (chartClick)="onChartClick(field, $event)"
      [initOpts]="initOption"
      [options]="chartOption"
      [autoResize]="true"
      class="chart-echart"
    ></div>
  </ng-container>
</ng-container>
<ng-template #kpiBlock>
  <div *ngIf="getSortedDataKeysLength() > 0; else noDataTemplate" class="chart-kpi-wrapper">
    <div
      echarts
      (chartInit)="onChartInit($event)"
      (chartClick)="onChartClick(field, $event)"
      [initOpts]="initOption"
      [options]="chartOption"
      [autoResize]="true"
      [ngClass]="{
        'chart-small-chart-container': kpiChartSize === 'small',
        'chart-medium-chart-container-with-toggle':
          kpiChartSize === 'medium' && includeToggleInHeightCalculation,
        'chart-medium-chart-container': kpiChartSize === 'medium',
        'chart-large-chart-container': kpiChartSize === 'large'
      }"
      [style.height]="getChartContainerHeight()"
    ></div>
  </div>
</ng-template>
<ng-template #noDataTemplate>
  <div class="chart-kpi-wrapper chart-kpi-no-data-wrapper">
    <drilldown-chart-no-data-available [size]="kpiChartSize"></drilldown-chart-no-data-available>
  </div>
</ng-template>
